import React, { useEffect, useRef } from "react";

// IMPORT USER-DEFINED COMPONENTS HERE //
import ExperienceCard from "components/experienceCard/ExperienceCard";
import { experienceList } from "config/experiences";
import { scrollToTop } from "utils/functions";

// IMPORT OTHERS HERE //
import appStyles from "./Experiences.module.scss";

const Experience = () => {
  // REFs
  const experiencesRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      scrollToTop({ isSmooth: false });
    }, 0);
  }, []);

  return (
    <main className={appStyles["main-cnt"]} id="experience" ref={experiencesRef}>
      <section className={appStyles.timeline}>
        {experienceList.map((experience, index) => (
          <ExperienceCard
            id={`experience-card-${index + 1}`}
            key={`experience-card-${index + 1}`}
            isLast={index === experienceList.length - 1}
            {...experience}
          />
        ))}
      </section>
    </main>
  );
};

export default Experience;
